import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

export const topicsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/topics',
  component: Topics,
});

function Topics() {
  return (
    <section>
      <h1 style={{ marginTop: 0 }}>Topic groups</h1>
      <p style={{ color: '#666' }}>
        Empty state. Create / link directory / archive flows land in WEB-004.
      </p>
      <button type="button" disabled>
        New topic group
      </button>
    </section>
  );
}
